import { TableColumnDefinition } from '@antimatterhq/ui/types/TableColumnDefinition';

export const detectionRulesTableColumnDefinitions: TableColumnDefinition[] = [
  {
    id: 'name',
    title: 'Name',
    width: 240,
  },
  {
    id: 'comment',
    title: 'Comment',
    width: 240,
  },
  {
    id: 'severity',
    tooltip: false,
    title: 'Severity',
    width: 160,
  },
  {
    id: 'rule',
    title: 'Rule last modified',
    hidden: true,
  },
  {
    id: 'version',
    title: 'Version',
    hidden: true,
  },
  {
    id: 'category',
    title: 'Category',
    hidden: true,
  },
  {
    id: 'fidelity',
    title: 'Fidelity',
    hidden: true,
  },
  {
    id: 'mitreTactic',
    title: 'MITRE tactic',
  },
  {
    id: 'mitreTechnique',
    title: 'MITRE technique',
  },
  {
    id: 'mitreTechniqueId',
    title: 'MITRE technique ID',
    hidden: true,
  },
  {
    id: 'subTechnique',
    title: 'Sub technique',
    hidden: true,
  },
  {
    id: 'subTechniqueId',
    title: 'Sub technique ID',
    hidden: true,
  },
  {
    id: 'objective',
    title: 'Objective',
    hidden: true,
  },
  {
    id: 'schedule',
    title: 'Schedule',
    hidden: true,
  },
  {
    id: 'inputTables',
    title: 'Input tables',
    hidden: true,
  },
  {
    id: 'edit',
    tooltip: false,
    title: '',
    width: 40,
    enableResize: false,
    enableFiltering: false,
    enableSorting: false,
    pinned: 'right',
  },
];
